import { connect } from 'react-redux'
import { selectBuyerNewHomeBudgetWithCap } from '../../../../../store/selectors/home/equity'
import { NewHomeDetail } from './NewHomeDetail'
import { CUSTOMER_MESSAGES } from '../../../../../constants/customerMessages'

export default {
  GemContainer: connect(state => ({
    qaTag: 'dreamHomeGem', // Leaving as old event label for backwards compatibility
    amount: selectBuyerNewHomeBudgetWithCap(state)
  })),
  Detail: NewHomeDetail,
  topicKey: CUSTOMER_MESSAGES.DREAM_HOME.topicKey,
  topic: CUSTOMER_MESSAGES.DREAM_HOME.topic,
  question: CUSTOMER_MESSAGES.DREAM_HOME.message
}
